import React, { useCallback } from 'react';
import axios from 'axios';
import config from '../../config/config';
import { usePsChat, MESSAGE_SENT } from '../../context/PsChatMessageContext';
import { useUserId, useUserRole } from '../../util_functions/helpers';

const MeetingEndedComponent = ({ threadId, userName, userRole }) => {
  const baseURL = config.API_BASE_URL;
  const userId = useUserId();
  const { state, dispatch } = usePsChat();

  const handleSessionTerminationConfirmation = useCallback(async (successful) => {
    if (!threadId) {
      console.error('Thread ID is missing. Cannot send feedback.');
      return;
    }

    const timestamp = Date.now();
    const payload = {
      userRole,
      successful,
      timestamp,
    };

    console.log('Payload:', payload);

    try {
      await axios.patch(
        `${baseURL}/v1/messages/meeting-completion-status/${threadId}`,
        payload
      );
      console.log('Update response:', payload);
    } catch (error) {
      console.error('Failed to send feedback:', error);
      return;
    }

    const now = Date.now();
    const thread = state.messages.find(t => t.id === threadId);
    const jobId = thread?.fullMessages?.[0]?.jobId;
    const text = successful
      ? `✅ <strong>${userName}</strong> <strong>(${userRole})</strong> confirmed the Meet & Greet completed successfully.`
      : `❌ <strong>${userName}</strong> <strong>(${userRole})</strong> indicated the Meet & Greet needs to be rescheduled.`;

    const newMsg = {
      text,
      chatMessageTimeStamp: now,
      sender: userRole,
      receiver: userRole === 'worker' ? 'client' : 'worker',
      jobId,
      read: false,
    };

    dispatch({
      type: MESSAGE_SENT,
      payload: { threadId, message: newMsg },
    });

    try {
      await axios.post(
        `${baseURL}/v1/messages/addChatMessage/${threadId}`,
        newMsg
      );
    } catch (err) {
      console.error('Error sending chat message:', err);
    }
  }, [baseURL, dispatch, state.messages, threadId, userRole, userName]);

  const handleSessionReschedule = useCallback(() => {
    console.log('Reschedule requested');
  }, []);

  return (
    <div className="session-completion-card">
      <h2>Did Your Meet &amp; Greet Go as Planned?</h2>
      <p>
        Please confirm whether your Meet & Greet session was successfully completed so we can proceed with the agreement.
        If not, you’ll need to reschedule.
      </p>
      <div className="button-group">
        <button
          className="confirm-button"
          onClick={() => handleSessionTerminationConfirmation(true)}
        >
          Yes, It was successful
        </button>
        <button
          className="cancel-button"
          onClick={() => handleSessionTerminationConfirmation(false)}
        >
          No, reschedule session
        </button>
      </div>
    </div>
  );
};

export default MeetingEndedComponent;
